export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #A8ABB5',
    borderRadius: '8px',
    background: '#EDEEF2',
    paddingY: '4px',
    cursor: 'pointer',
    maxWidth: '185px',
    height: '38px',
    overflow: 'hidden',
    marginRight: '20px',
  },
  divider: {
    background: '#4D6EF5',
    height: '12px',
    opacity: '0.5',
    width: '0.5px',
    marginX: '12px',
  },
  typo: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#23252F',
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 400,
    flexShrink: 1,
  },
  arrowRightIcon: {
    paddingLeft: '16px',
    paddingRight: '21px',
    flexShrink: 0,
  },
  draftIcon: {
    marginLeft: '12px',
  },
};
